import { ColumnDef } from "@tanstack/react-table";
import { ServiceTitanIconLink } from "@/core/components/service-titan-icon-link";
import { Stack } from "@/core/components/ui/stack";
import type { IcmJob } from "@/icm/types";

const CustomerNameCol: ColumnDef<IcmJob, unknown> = {
  id: "customer_name",
  accessorKey: "customer_name",
  header: "Customer",
  meta: { size: "200px" },
  cell: ({ row }) => {
    const { customer_name, job_number, job_id } = row.original;
    return (
      <Stack gap="none">
        <span>{customer_name ?? "-"}</span>
        <span className="inline-flex items-center text-xs text-tertiary-text">
          {job_number ?? "-"}
          {job_id && (
            <ServiceTitanIconLink
              url={`/#/Job/Index/${job_id}`}
              label={`Open ServiceTitan job ${job_id}`}
              stopPropagation
            />
          )}
        </span>
      </Stack>
    );
  },
};

export default CustomerNameCol;
